// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sza-vect-item {\n  display: inline-block;\n  background: #f0f0f0;\n  margin: 4px 4px 4px 0;\n  border-radius: 4px;\n  border: 0;\n  padding: 3px 5px;\n}\n.vect-input-container {\n  display: flex;\n  flex-direction: row;\n}\n.vect-input-container .vect-input {\n  display: flex;\n  flex-direction: column;\n  margin-right: 2px;\n}\n.vect-input-container .vect-input .state {\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
